import { getInstanceByDom } from 'echarts';

import { htmlNodes } from './htmlNodes';

export const generateImageTag = (chartRef: HTMLDivElement) => {
  const canvases = chartRef?.querySelectorAll('canvas');

  if (!canvases || canvases.length === 0) {
    return '';
  }

  const chartInstance = getInstanceByDom(chartRef);

  // For standard images (excludes dynamically generated chart images)
  if (!chartInstance) {
    return Array.from(canvases)
      .map(canvas => htmlNodes.img(canvas.toDataURL('image/png', 1.0)))
      .join('');
  }

  const imageTags = Array.from(canvases)
    .map(canvas => {
      const imageDataUrl = canvas.toDataURL('image/png', 1.0);
      return htmlNodes.img(imageDataUrl);
    })
    .join('');

  return imageTags;
};
